module.exports = __webpack_public_path__ + "media/images/lp_step1-20390d2e0f53294eab67b4f7b0e35d7c.webp";